export default __webpack_public_path__ + "static/media/call.1c4c8400.svg";